import { EventSearchForm } from '@mark43/cad-api';
import { FilterSummary } from '../search-windows/filter-summary';
import { FiltersSummary } from '../search-windows/filters-summary';

export function OtherFiltersSummary({ eventSearchForm }: { eventSearchForm: EventSearchForm }) {
    return (
        <FiltersSummary title="Other">
            <FilterSummary label="Has attachment(s)" option={eventSearchForm.hasAttachments} />
            <FilterSummary label="File name" stringValue={eventSearchForm.attachmentFileName} />
            <FilterSummary label="File types" options={eventSearchForm.attachmentCategories} />
            <FilterSummary
                label="File description"
                stringValue={eventSearchForm.attachmentDescription}
            />

            <FilterSummary
                label="Include Active Events"
                key="Include Active Events"
                booleanValue={eventSearchForm.includeActiveEvents}
            />
            <FilterSummary
                label="Enable Fuzzy Matching"
                key="Enable Fuzzy Matching"
                booleanValue={eventSearchForm.fuzzyMatchingEnabled}
            />
        </FiltersSummary>
    );
}
